import { BusinessParamName, MessageType, TechnicalParamName, TechnicalParamValue } from './request-offer.enum';

export interface RequestHeader {
  languageCode?: string;
  requestId?: string;
  responseId?: string;
  messageType?: MessageType;
  requestDate?: Date;
  responseDate?: Date;
  processContext: ProcessContext;
  technicalParameters?: Array<TechnicalParameter>
}

export class ProcessContext {
  processId?: string;
  businessParameters: Array<BusinessParameter>;

  constructor() {
    this.processId = null;
    this.businessParameters = new Array<BusinessParameter>();
  }
}

export interface TechnicalParameter {
  parameterName: TechnicalParamName;
  parameterValue: TechnicalParamValue | string | boolean;
}

export interface BusinessParameter {
  parameterName: BusinessParamName;
  parameterValue: string | string[] | boolean;
}
